module.exports = __webpack_public_path__ + "img/center.0c996e94.png";